/**
 * @generated SignedSource<<ffc633d5c84ef88647472f46786b433d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type morningStudioArticleContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"headerMorningStudioArticle">;
  readonly " $fragmentType": "morningStudioArticleContent";
};
export type morningStudioArticleContent$key = {
  readonly " $data"?: morningStudioArticleContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"morningStudioArticleContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "morningStudioArticleContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "headerMorningStudioArticle"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "41ca3594002addd8ad2f76e3eedfe521";

export default node;
